<template>
  <div class="functions-dict" ref="container">
    <div class="questions-box flex-c-b">
      <div class="question">沈小布脱敏下?</div>
      <div class="answer" v-if="answer1">{{answer1}}</div>
      <el-button type="primary" v-if="!answer1" @click="desensitization('沈小布', {maskType: 'name'}, 'answer1')">点击获取结果</el-button>
    </div>
    <div class="questions-box flex-c-b">
      <div class="question">18830593872脱敏下?</div>
      <div class="answer" v-if="answer2">{{answer2}}</div>
      <el-button type="primary" v-if="!answer2" @click="desensitization('18830593872', {maskType: 'mobile'}, 'answer2')">点击获取结果</el-button>
    </div>
    <div class="questions-box flex-c-b">
      <div class="question">350624199501051314脱敏下?</div>
      <div class="answer" v-if="answer3">{{answer3}}</div>
      <el-button type="primary" v-if="!answer3" @click="desensitization('350624199501051314', {maskType: 'idCard'}, 'answer3')">点击获取结果</el-button>
    </div>
    <div class="questions-box flex-c-b">
      <div class="question">宁夏回族自治区金滩村涌泉街道脱敏下?</div>
      <div class="answer" v-if="answer4">{{answer4}}</div>
      <el-button type="primary" v-if="!answer4" @click="desensitization('宁夏回族自治区金滩村涌泉街道脱敏下', {maskType: 'idCard'}, 'answer4')">点击获取结果</el-button>
    </div>
    <div class="questions-box flex-c-b">
      <div class="question">19950105日期格式化一下?</div>
      <div class="answer" v-if="answer5">{{answer5}}</div>
      <el-button type="primary" v-if="!answer5" @click="formatDate('19950105', 'date', 'answer5')">点击获取结果</el-button>
    </div>
    <div class="questions-box flex-c-b">
      <div class="question">19950105141222日期时间格式化一下?</div>
      <div class="answer" v-if="answer6">{{answer6}}</div>
      <el-button type="primary" v-if="!answer6" @click="formatDate('19950105141222', 'datetime', 'answer6')">点击获取结果</el-button>
    </div>
    <el-button type="primary" @click="reset">重置</el-button>
  </div>
</template>

<script>
import {formatDate, desensitization} from "~/index.js"
export default {
  name: "functions-other",
  data() {
    return {
      answer1: "",
      answer2: "",
      answer3: "",
      answer4: "",
      answer5: "",
      answer6: ""
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        const container = this.$refs.container
        const data = {"demoContainerHeight": container.scrollHeight + 20}
        window.parent.postMessage(data, "*")
      }, 1000)
    })
  },
  methods: {
    reset() {
      this.answer1 = this.answer2 = this.answer3 = this.answer4 = this.answer5 = this.answer6 = ""
    },
    //通过值获取中文值
    desensitization(val, options, answer) {
      this[answer] = desensitization(val, options)
    },
    formatDate(val, type, answer) {
      this[answer] = formatDate(val, type)
    }
  }
}
</script>

<style scoped>
.questions-box{
  margin-bottom: 20px;
}
</style>